import React from 'react';

import { Props } from './@types';
import Form from './Form';

export default ({ current, send }: Props) => <Form current={current} send={send} isDisabled={true} />;
